import React, { memo } from 'react';

import { FormProvider } from 'react-hook-form';

import { useBattleCardsStore } from 'store/battlecards.store';

import { ToggleView } from 'components/common/ToggleView/ToggleView';
import { Separator } from 'components/common/WidgetWithTitle/Separator/separator';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { useMainFiltersLogic } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.logic';
import { useMainFiltersProvider } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.provider';
import { ClearButton } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/ClearButton/ClearButton';
import { Filters } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters';
import { BulkAssignWrapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/bulkAssign/bulkAssignWrapper';
import { ActivitiesSegments } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/components/ActivitiesSegments/ActivitiesSegments';
import CustomizeFilter from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/customizeFilter/customizeFilter';
import { Button } from 'components/DesignSystem/Button';

import classes from './MainFilters.module.scss';

export const MainFilters = memo(() => {
    const displayStyle = useBattleCardsStore((state) => state.displayStyle);
    const { setDisplayStyle } = useBattleCardsStore();

    const { api, ui } = useMainFiltersProvider();
    const { logic } = useMainFiltersLogic({ api, ui });

    return (
        <FormProvider {...ui.form}>
            <div data-testid={'main-filters'} className={classes.mainFiltersContainer}>
                <form onSubmit={ui.form.handleSubmit(logic.onFiltersChanged)}>
                    <WidgetWithTitle
                        className={classes.filtersWidgetWithTitleContainer}
                        title={'Filters'}
                        titleComponents={
                            <div className={classes.titleComponents}>
                                <CustomizeFilter ui={ui} logic={logic} />

                                <Button
                                    size={'medium'}
                                    variant={'primary'}
                                    type={'submit'}
                                    className={classes.hideButton}
                                >
                                    Apply Filters
                                </Button>

                                <ClearButton />
                                <ActivitiesSegments />
                                <Separator className={classes.separator} />
                                <BulkAssignWrapper />
                                <ToggleView displayStyle={displayStyle} setDisplayStyle={setDisplayStyle} />
                            </div>
                        }
                    >
                        <Filters api={api} ui={ui} logic={logic} />
                    </WidgetWithTitle>
                </form>
            </div>
        </FormProvider>
    );
});
